export const styles = (theme) => ({
  paper: {
    padding: "2rem",
  },
});
